// extracted by mini-css-extract-plugin
export default {"Main__Spinner":"Loading_Main__Spinner__zY5jQ","rotate":"Loading_rotate__OpWKL"};